// extracted by mini-css-extract-plugin
export var compactFilters = "_fh-4";
export var detailImage = "_fh-1";
export var dropdownContainer = "_fh-2";
export var imageContainer = "_fh-0";
export var selectedCard = "_fh-3";